export const setFallbackWithException = (fallback: any, value: string, msg = ''): any => {
  if (!msg) {
    const defaultMsg = `${value} not available`
    console.error(defaultMsg)
  }
  return fallback
}
